import { Component } from 'react';
import { connect } from 'react-redux';
import FileDownload from 'react-file-download';
import Title from '../../common/page-title/index';
import { getDataExports } from '../../../actions/data-export';
import irelandApi from '../../../irelandApi';

import './style.css';

class DataExport extends Component {
  static downloadCSV(url) {
    irelandApi.get(url)
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        let headerFilename = null;
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const match = filenameRegex.exec(disposition);
          if (match && match[1]) {
            headerFilename = match[1].replace(/["']/g, '').trim();
          }
        }
        FileDownload(response.data, headerFilename || 'export.csv');
      })
      .catch(() => { /* none */
      });
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getDataExports());
  }

  renderLinks() {
    const links = [];

    this.props.data_exports.list.forEach((curr) => {
      links.push((
        <div key={curr.label}>
          <a
            className="export-link"
            onClick={() => {
              DataExport.downloadCSV(curr.url);
            }}
          >
            {curr.label}
          </a>
        </div>
      ));
    });

    return links;
  }

  render() {
    return (
      <div className="container-fluid data-export">
        <Title>
          Data Export
        </Title>
        {this.renderLinks()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data_exports: state.data_exports
});

export default connect(mapStateToProps)(DataExport);
